import React, {Component} from 'react';
import edit from '../../resources/images/estrategas/tools/edit.svg';
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import * as Request from '../../service/data-info-chart/requestsUtil';
import {
  EDIT_SATISFACTION_INDEX,
  PARTICULAR_RESULTS,
  SATISFACTION_INDEX,
  SAVE_PARTICULAR_RESULTS
} from '../../utils/constants';
import Rate from 'rc-rate';
import '../../../node_modules/rc-rate/assets/index.css';
import * as Parse from '../../utils/parsers';
import View from '../buttons/view';
// import Download from '../buttons/download';
import Save from '../buttons/save';


class UnitBusinessRate extends Component {

  constructor(props) {
    super(props);
    let today = Parse.toCustomDateLastDay(new Date());
    this.toggle = this.toggle.bind(this);
    this.editActions = this.editActions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      modal: false,
      places: [],
      value: 0,
      key: null,
      date: today,
      text: '',
      grade: null,
      gradePrev: null
    };
  }

  componentDidMount() {
    this._Fetch();
  }

  _Fetch() {
    Request.getFetch(SATISFACTION_INDEX + this.props.bu.id + '/' + this.props.date)
      .then((value) => {
        this.setState({value: value, gradePrev: value.grade, textNote: value.note});
      });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({[name]: value});
  }

  editActions() {
    let grade = (this.state.grade >= 0 && this.state.grade <= 5 && this.state.grade !== null
      && this.state.grade !== '') ? this.state.grade : this.state.gradePrev;

    const params = {
      businessUnit: this.props.bu.id,
      grade: grade,
      date: this.props.date,
      note: this.state.text
    };
    Request.postFetch(EDIT_SATISFACTION_INDEX, params)
      .then(() => {
        this._Fetch();
        this.setState({key: Math.random() * 10});
      });
    this.toggle();
  }

  render() {

    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';

    let grade = (Math.round(this.state.value.grade * 2)) / 2;

    return (
      <div>
        <div className={this.props.nameClass}>
          <div className='container-fluid'>
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader className='header-modal'
                           toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
              <ModalBody>
                <div className='d-flex justify-content-end m-3'>
                  <p className='mb-0 mr-2'>Satisfacción del cliente de {this.props.bu.name}:</p>
                  <Input placeholder="# numero entre 0 y 5" type="text" name="grade" id="grade"
                         value={this.state.grade} onChange={this.handleChange}
                         style={{width: '50%'}}/>
                </div>
                <div className='m-3'>
                  <p className='mb-0 mr-2'>Agregue una nota:</p>
                  <Input type='textarea' name='text' id='text'
                         value={this.state.text} onChange={this.handleChange}
                         style={{height:'100px'}} maxLength={500}/>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.editActions}>Aceptar</Button>{' '}
                <Button color="danger" onClick={this.toggle}>Cancelar</Button>
              </ModalFooter>
            </Modal>
            <div className='row'>
              <div className='col-lg-6 col-12 margin-rates pt-2 pb-2'>
                <div className={classUser}>
                  <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
                </div>
                <div className='container-fluid quality-title-3'>
                  Resultado de {this.props.bu.name}
                </div>
                <div className='d-flex justify-content-center align-items-center margin-stars'>
                  <div className='stars-rate' key={this.state.key}>
                    <Rate
                      value={grade}
                      style={{fontSize: 80}}
                      allowHalf
                      allowClear={false}
                    />
                  </div>
                  <div className='rate-number'>
                    {this.state.value.grade}
                  </div>
                </div>
                <Input readOnly type='textarea' name='text' id='text' value={this.state.textNote} style={{height:'100px'}}/>
              </div>
              <div className='col-lg-6 col-12 margin-rates'>
                <Save url={SAVE_PARTICULAR_RESULTS} authorization={this.props.authorization}
                      bu={this.props.bu.id} date={this.props.date}/>
                <div
                  className='p-lg-5 p-0 pt-lg-5 pb-lg-5 pt-3 pb-3 m-0 d-flex justify-content-center'>
                  <div className='d-flex justify-content-center quality-title-3'>
                    Resultados particulares
                  </div>
                  <div className='d-flex text-right ml-lg-3 ml-3'>
                    <View url={PARTICULAR_RESULTS + this.props.bu.id + '/' + this.props.date}
                          date={this.props.date}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UnitBusinessRate;



// WEBPACK FOOTER //
// ./src/components/satisfactionIndex/unitBusinessRate.js